
/*
 * https://developerx.atlassian.net/browse/CS-4784
 * https://developerx.atlassian.net/browse/CS-4940
 * https://developerx.atlassian.net/browse/CS-4941
 * https://developerx.atlassian.net/browse/CS-4942
 * https://developerx.atlassian.net/browse/CS-4943
 * https://developerx.atlassian.net/browse/CS-4944
 * https://developerx.atlassian.net/browse/CS-4945
 * https://developerx.atlassian.net/browse/CS-4946
 *
 * Created at : 27 Jan 2022           Updated at : 09 Feb 2022
 * Created by : Risman Abdilah        Updated by : Risman Abdilah
 *
 * Version 2.3.0
 */

import $ from "jquery";
import Vue from "vue";
import i18n from "@/i18n";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { CandidateModel } from "@/models/candidate.model";
import { SectionProfileCandidate } from "@/constants/enum.constant";

import Badge from "@/components/properties/Badge.vue";
import ModalEducation from "@/components/candidate/profile/ModalEducation.vue";
import ModalWorkExperience from "@/components/candidate/profile/ModalWorkExperience.vue";
import ModalOrganization from "@/components/candidate/profile/ModalOrganization.vue";
import ModalSkill from "@/components/candidate/profile/ModalSkill.vue";
import ModalLanguage from "@/components/candidate/profile/ModalLanguage.vue";
import ModalPersonality from "@/components/candidate/profile/ModalPersonality.vue";
import ModalAchievement from "@/components/candidate/profile/ModalAchievement.vue";
import ModalPortfolio from "@/components/candidate/profile/ModalPortfolio.vue";
import ModalConfirmDelete from "@/components/candidate/ModalConfirmDelete.vue";

@Component({
  components: {
    Badge,
    ModalEducation,
    ModalWorkExperience,
    ModalOrganization,
    ModalSkill,
    ModalLanguage,
    ModalPersonality,
    ModalAchievement,
    ModalPortfolio,
    ModalConfirmDelete,
  },
  filters,
})
export default class CandidateEdit extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectCandidateById", { namespace: "candidate" })
  private actionSelectCandidateById: any;
  @Action("actionDeleteCandidateEducation", { namespace: "candidate" })
  private actionDeleteCandidateEducation: any;
  @Action("actionSelectSchoolTypeList", { namespace: "academy" })
  private actionSelectSchoolTypeList: any;

  // STATE
  @State("candidate", { namespace: "candidate" })
  private candidate: CandidateModel;
  @State("school", { namespace: "academy" })
  private school: any;
  @State("locale")
  private locale: any;

  /* INITIALIZATION */
  private showContent: boolean = false;
  private activeSection = "profile";

  // https://developerx.atlassian.net/browse/CS-4783
  private showModalEducation = false;
  private isEditEducation = false;
  private selectedEducation: any = null;
  // https://developerx.atlassian.net/browse/CS-4940
  private showModalWorkExperience = false;
  private selectedWorkExperience: any = null;
  // https://developerx.atlassian.net/browse/CS-4941
  private showModalOrganization = false;
  private selectedOrganization: any = null;
  // https://developerx.atlassian.net/browse/CS-4942
  private showModalSkill = false;
  // https://developerx.atlassian.net/browse/CS-4943
  private showModalLanguage = false;
  // https://developerx.atlassian.net/browse/CS-4944
  private showModalPersonality = false;
  // https://developerx.atlassian.net/browse/CS-4945
  private showModalAchievement = false;
  private selectedAchievement: any = null;
  // https://developerx.atlassian.net/browse/CS-4946
  private showModalPortfolio = false;
  private selectedPortfolio: any = null;

  private showModalConfirmDelete = false;
  private modalDeleteTitle: any = "";
  private modalDeleteMessage: any = "";
  private sectionDelete = 1;
  private deletedId = 0;

  isAuthorized=false

  constructor() {
    super();
  }

  private created() {
    this.actionSelectCandidateById(this.$route.params.id);
  }

  /* LIFECYCLE */

  private mounted() {
    // this.actionSelectCandidateById(this.$route.params.id);
    $(document).ready(function () {
      // Bind to scroll
      $(window).scroll(function () {
        var scrollPos: any = $(document).scrollTop();
        $(".candidateInfo").each(function () {
          var currLink = $('[data="' + $(this).attr("id") + '"]');
          var height: any = $(this).height();

          if (
            $(this).position().top <= scrollPos &&
            $(this).position().top + height + 100 > scrollPos
          ) {
            $("#menu ul li").removeClass("active");

            currLink.parent().addClass("active");
          } else {
            // currLink.parent().removeClass("active");
          }
        });
      });
    });
  }

  /* METHODS */
  private onDelete() {
    switch (this.sectionDelete) {
      case SectionProfileCandidate.EDUCATION:
        const candidateId = this.$route.params.id;
        this.actionDeleteCandidateEducation({
          params: { candidateId, educationId: this.deletedId },
          success: () => {
            this.actionSelectCandidateById(candidateId);
            this.showModalConfirmDelete = false;
            this.modalDeleteTitle = "";
            this.modalDeleteMessage = "";
            this.sectionDelete = 1;
            this.deletedId = 0;
          },
        });
        break;
      default:
        console.log("Section candidate profile not found");
        break;
    }
  }

  private onAddEducation() {
    this.selectedEducation = null;
    this.showModalEducation = true;
    this.isEditEducation = false;
    this.actionSelectSchoolTypeList();
  }

  private onEditEducation(education: any) {
    this.selectedEducation = education;
    this.showModalEducation = true;
    this.isEditEducation = true;
    this.actionSelectSchoolTypeList();
  }

  private onDeleteEducation(education: any) {
    this.showModalConfirmDelete = true;
    this.modalDeleteTitle = i18n.t("modal_title_delete_education", { education: education.school.name });
    this.modalDeleteMessage = i18n.t("modal_message_delete_education");
    this.sectionDelete = SectionProfileCandidate.EDUCATION;
    this.deletedId = education.id;
  }

  private onSuccessEducation() {
    // TODO
  }

  private onAddWorkExperience() {
    this.selectedWorkExperience = null;
    this.showModalWorkExperience = true;
  }

  private onEditWorkExperience(work: any) {
    this.selectedWorkExperience = work;
    this.showModalWorkExperience = true;
  }

  private onDeleteWorkExperience(work: any) {
    // TODO
  }

  private onSuccessWorkExperience() {
    // Todo
  }

  private onAddOrganization() {
    this.selectedOrganization = null;
    this.showModalOrganization = true;
  }

  private onEditOrganization(organization: any) {
    this.selectedOrganization = organization;
    this.showModalOrganization = true;
  }

  private onDeleteOrganization(organization: any) {
    // TODO
  }

  private onSuccessOrganization() {
    // Todo
  }

  private onAddSkill() {
    this.showModalSkill = true;
  }

  private onSuccessSkill() {
    // Todo
  }

  private onAddLanguage() {
    this.showModalLanguage = true;
  }

  private onSuccessLanguage() {
    // Todo
  }

  private onAddPersonality() {
    this.showModalPersonality = true;
  }

  private onSuccessPersonality() {
    // Todo
  }

  private onAddAchievement() {
    this.selectedAchievement = null;
    this.showModalAchievement = true;
  }

  private onEditAchievement(achievement: any) {
    this.selectedAchievement = achievement;
    this.showModalAchievement = true;
  }

  private onDeleteAchievement(achievement: any) {
    // TODO
  }

  private onSuccessAchievement() {
    // Todo
  }

  private onAddPortfolio() {
    this.selectedPortfolio = null;
    this.showModalPortfolio = true;
  }

  private onEditPortfolio(portfolio: any) {
    this.selectedPortfolio = portfolio;
    this.showModalPortfolio = true;
  }

  private onDeletePortfolio(portfolio: any) {
    // TODO
  }

  private onSuccessPortfolio() {
    // Todo
  }

  private clickBack() {
    this.$router.push({
      name: "candidateDetail",
      params: { id: this.candidate.id.toString() },
    });
  }

  private getMajor(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["major"];
  }

  private getDegree(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["degree"];
  }

  private getLanguage(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["language"];
  }

  private scrollTo(section: string) {
    var offset = ($(`#${section}`) as any).offset();
    var winHeight = $("#main-section").height();
    const headerHeight: any = $("#headerPersonal").height();
    $("html, body").animate(
      {
        scrollTop: offset.top - headerHeight - 150,
      },
      500
    );
    this.activeSection = section;
  }
}
